/** biome-ignore-all lint/performance/noBarrelFile: no barrel file */
/** biome-ignore-all lint/performance/noReExportAll: no re export all */
import { type Content, type ContentRelationshipField, type ImageFieldImage, isFilled, type KeyTextField, type LinkField, type RichTextField } from '@prismicio/client';
import { PrismicImage, PrismicLink, PrismicToolbar } from '@prismicio/react';
import { PrismicButton, PrismicRichText } from './components';
import PrismicPreviewPage from './pages/PrismicPreviewPage';
import dashboardClient, { repositoryName as dashboardRepositoryName } from './prismic';
import neoMidasClient, { repositoryName as neoMidasRepositoryName } from './prismicNeoMidas';
import supportClient, { repositoryName as supportRepositoryName } from './prismicSupport';

// types
export * as DashboardTypes from './types/herbie-dashboard.generated';
export * as NeoMidasTypes from './types/neo-midas.generated';
export * as SupportTypes from './types/support-cobli.generated';

const CustomPrismicToolbar = () => {
  setTimeout(() => {
    return (
      <>
        <PrismicToolbar repositoryName={dashboardRepositoryName} />
        <PrismicToolbar repositoryName={neoMidasRepositoryName} />
        <PrismicToolbar repositoryName={supportRepositoryName} />
      </>
    );
  }, 5000);
  return null;
};

export type { Content, ContentRelationshipField, KeyTextField, ImageFieldImage, LinkField, RichTextField };

export {
  isFilled,
  PrismicButton,
  PrismicImage,
  PrismicLink,
  PrismicPreviewPage,
  PrismicRichText,
  CustomPrismicToolbar as PrismicToolbar,
  dashboardClient,
  neoMidasClient,
  supportClient,
};
